import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import React from 'react';
import './index.css';
import './i18n';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LanguageWrapper from './LanguageWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route path="/:lang/*" element={<LanguageWrapper />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();